export default __webpack_public_path__ + "assets/e51ef0e020636d18ef631e4c4aedea43.png";